module.exports = __webpack_public_path__ + "img/1-2.5c873a87.png";